export const GET_BLOGS = 'blogs/allBlogs/get';
export const GET_RECENT_BLOGS = 'blogs/recentBlogs/get';
export const GET_BLOGS_PAGED = 'blogs/allBlogsPaged/get';
export const GET_BLOG_BY_ID = 'blogs/blogById/get';
export const GET_BLOG_BY_SLUG = 'blogs/blogBySlug/get';
export const GET_CATEGORY_BLOGS = 'blogs/allCategoryBlogs/get';
export const GET_CATEGORY_BLOG_BY_ID = 'blogs/categoryBlogById/get';